<template>
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card card-w-title">
                <div class="manager-title">Tạo và in serial number</div>
            </div>
            <div class="card card-w-title" v-if="$myConstants.checkRoleGroup('serial_number_add', 'add')">
                <div class="box-title">Vui lòng nhập các thông tin dưới đây để tạo serial number và label QRcode</div>
                <div class="p-fluid p-grid create-serial-number">
                    <div class="p-field p-col-2 width-prefix">
                        <label >Tiền tố  (2 ký tự)</label>
                        <InputText @input="changeData"  maxlength="2" id="prefix" v-model="prefix" type="text" placeholder="00"/>
                        <small v-if="submit && prefixError != ''" class="p-invalid" > {{ prefixError }}</small>
                    </div>
                    <div class="p-field p-col-3 width-amount">
                        <label >Số lượng sản xuất</label>
                        <InputNumber @input="changeData" v-model="amount" placeholder="0"/>
                        <small v-if="submit && amountError != ''" class="p-invalid" > {{ amountError }}</small>
                    </div>
                    <div class="p-field p-col-4 width-300">
                        <label >Lệnh sản xuất</label>
                        <InputText autocomplete="off"  @input="changeData" maxlength="20" placeholder="Nhập lệnh sản xuất" id="production_code" v-model="production_code" type="text" />
                        <small v-if="submit && productionError != ''" class="p-invalid" > {{ productionError }}</small>
                    </div>
                    <div class="p-field p-col-4 width-300 margin-right">
                        <label >Ngày sản xuất</label>
                        <Calendar @input="changeInput" id="icon" v-model="created_date" :showIcon="true" placeholder="Nhập ngày sản xuất" />
                        <small v-if="submit && dateError != ''" class="p-invalid" > {{ dateError }}</small>
                    </div>
                    <div class="p-field p-col-4 width-300">
                        <label >Model sản phẩm</label>
                      <v-select  :filterable="false"  placeholder="Chọn model sản phẩm" v-model="productItem"  :options="products" :reduce="products => products.value"  label="name" @input="changeData"    @search="fetchOptionsProductList">
                      <span slot="no-options" @click="$refs.select.open = false">
                      {{ $dataCommon.TEXT_NOT_FIND_DATA_SELECT }}
                    </span>
                      </v-select>
                        <!--<Dropdown @input="changeData" :filter="true" v-model="productItem" :options="products" optionLabel="name" optionValue="value" placeholder="Chọn model sản phẩm" />
                      -->  <small v-if="submit && productError != ''" class="p-invalid" > {{ productError }}</small>
                    </div>
                    <div class="p-field btn-submit">
                        <Button :class="disabled ? 'disabled' : ''"  icon='pi pi-cog' label='Tạo serial number'  @click="handleClick()" />
                    </div>
                </div>
            </div>
            <!-- v-if="checkVisible('history')" -->
            <div class="card card-w-title" v-if="checkVisible('serial_number_add', 'history')" >
                <div class="list-data">
                    <div class="list-title">
                        <span class="p-m-0">Danh sách lịch sử tạo serial number</span>
                    </div>
                    <BaseCommon v-if="dataModel"
                        :key="componentKey"
                        :listData="listData"
                        :model="dataModel"
                        :filterDefault="filters"
                        :actions="getRowActions()"
                        v-on:action-click="onActionClicked"
                    ></BaseCommon>
                </div>
            </div>
        </div>
        <Dialog 
          :header="'Xác nhận'"
          :visible.sync="displayDialog"
          :contentStyle="{overflow: 'visible'}"
          :style="{width: '50vw'}"
          :class="'popup-confirm'"
          :modal="true"
        >
        <div class="content-confirm txt-center">
            <div >Xác nhận bắt đầu tiến trình tạo serial number ?</div>
            <div v-html="note_confirm"></div>
            <div class="box-data-duplicate" v-if="dataModelDuplicate">
                <BaseCommon
                    :key="componentKeyDuplicate"
                    :listData="listDataDuplicate"
                    :isFilter="false"
                    :pagination="false"
                    :model="dataModelDuplicate"
                    @filterExport="filterExport"
                ></BaseCommon>
            </div>
        </div>
        <template #footer>
            <Button  :label="'Đồng ý'" @click="confirmCreated" autofocus />
            <Button class="p-button-danger" :label="'Huỷ'" @click="cancelCreated" />
        </template>
        </Dialog>

        <Dialog 
            :header="'Xác nhận'"
            :visible.sync="displayConfirmDialog"
            :contentStyle="{overflow: 'visible'}"
            :style="{width: '40vw'}"
            :class="'popup-confirm  dialog-header-custom'"
            :modal="true"
            :closable="false"
            >
            <template #header>
                <slot name="header">
                    <span  class="p-dialog-title" >Xác nhận</span>
                </slot>
                <div class="p-dialog-header-icons">
                    <button class="p-dialog-header-icon p-dialog-header-close p-link" @click="confirmContinue" >
                        <span class="p-dialog-header-close-icon pi pi-times"></span>
                    </button>
                </div>
            </template>
            <div class="content-confirm txt-center">
                <div >Bạn muốn huỷ và kết thúc quá trình tạo serial number ?</div>
            </div>
            <template #footer>
                <Button  :label="'Đồng ý'" @click="confirmStopped" />
                <Button class="p-button-danger" :label="'Huỷ'" @click="confirmContinue" autofocus />
            </template>
        </Dialog>

        <Dialog 
            :header="'Xác nhận'"
            :visible.sync="displayProgressDialog"
            :contentStyle="{overflow: 'visible'}"
            :style="{width: '50vw'}"
            :class="'popup-confirm'"
            :modal="true"
            :showHeader="false"
            >
            <div class="content-confirm txt-center">
                <p >Đang tạo serial number, vui lòng đợi ... ?</p>
                <ProgressBar  :value="processRows" />
            </div>
            <template #footer>
                <Button class="p-button-danger" :label="'Huỷ tạo'" @click="confirmCancel" autofocus />
            </template>
        </Dialog>
    </div>
</template>

<script>
import moment from "moment-timezone";
import DataServices from '@/core/DataServices'
//import BaseCommon from '../common'
import BaseCommon from './core_list_function';
export default {
  components: {
    BaseCommon
  },
  data() {
    return {
        filters: {},
        listData: [],
        dataModel: null,
        componentKey: 0,
        prefix: '00',
        prefixError: '',
        amount: 0,
        amountError: '',
        production_code: '',
        productionError: '',
        created_date: moment(new Date()).format('DD/MM/YYYY'),
        dateError: '',
        productsAll: [],
        products: [],
        productError: '',
        productItem: 0,
        submit: false,
        disabled: true,
        displayDialog: false,
        displayConfirmDialog: false,
        displayProgressDialog: false,
        noteConfirm: '<b>Lưu ý: Lệnh sản xuất {0} đã tạo {1} serial number trước đó</b>',
        note_confirm: '',
        processRows: 0,
        stopProgress: false,
        countDown: 0,
        listDataDuplicate: [],
        dataModelDuplicate: null,
        componentKeyDuplicate: 0,
        data_filter_export:null
    }
  },
  
  watch: {
    '$route': 'initData'
  },
  async created () {
    await this.initData();
  },
  methods: {
    async fetchOptionsProductList (search, loading) {
      console.log(loading);
      if (!this.$myConstants.isEmpty(search)){
        var list= [];
        var search_convert = this.$myConstants.SkipVN(search).trim();
        for (var i=0;i<this.productsAll.length;i++){
          var textSearch = this.$myConstants.SkipVN(this.productsAll[i].name);
          var keySearch = textSearch.search(search_convert);
          if (keySearch > -1){
            list.push(this.productsAll[i]);
          }
        }
        this.products =list;
      }else {
        this.products = this.productsAll;
      }
      //console.log(this.listChilds)
      return false;
    },
    checkVisible(groupName, action) {
      return this.$myConstants.checkVisible(this.$store.getters.permission, groupName, action);
    },
    initData() {
      setTimeout(async () => {
        if (this.checkVisible('serial_number_add', 'history')) {
            await this.getProducts();
            await this.initParams();
        }
      }, 1000);
    },
    changeInput($event) {
      var dateNow = new Date();
      var date = new Date(moment($event).format('YYYY-MM-DD'));
      dateNow = new Date(moment(dateNow).format('YYYY-MM-DD'));
      if (Number(dateNow) > Number(date)) {
        this.created_date = '';
      } else this.created_date = moment(date).format('DD/MM/YYYY');
      this.disabled = (this.prefix.length < 2 || this.amount.length == 0 || this.production_code.trim().length == 0 || this.created_date.length == 0  ||  this.productItem  ==  0) ? true : false;
    },
    changeData() {
        this.disabled = (this.prefix.length < 2 || this.amount.length == 0 || this.production_code.trim().length == 0 || this.created_date.length == 0 ||  this.productItem  ==  0) ? true : false;
    },
    async getProducts() {
      this.products =await this.$coreService.list_all_product();
      this.productsAll = this.products;
      /*var variables = {
        where_key: {
          status: {'_in': [1] },
          production_status: {'_eq': 1},
          categories: {
            status: {'_eq': 1}
          }
        },
        orderBy: {
          name: 'asc',
          created_date: 'desc'
        }
      }
      var data = await DataServices.getList('product', {"variables": JSON.stringify(variables), "fields": 'id name model_code'});
      var list = data[Object.keys(data)];
      if (list != null && Object.keys(list).length) {
          for (let index = 0; index < list.length; index++) {
            var pro = list[index];
            this.products.push({name: pro.model_code + ' - ' + pro.name, value: pro.id});
          }
      }*/
    },
    async handleClick() {
        if (!this.disabled) {
            this.submit = true;
            var count = 0;
            this.production_code = this.production_code.trim();
            var check = this.$myConstants.isValid(this.prefix);
            if (check) { this.prefixError = 'Tiền tố không hợp lệ'; count++;}
            var checkCode = this.$myConstants.isValid(this.production_code);
            if (checkCode) {this.productionError = 'Lệnh sản xuất không hợp lệ';  count++; }
            if (this.created_date.length == 0) {this.dateError = 'Nhập ngày sản xuất';  count++; }
            if (this.amount == 0) {this.amountError = 'Không được nhập số 0';  count++; }
            if (this.amount < 0) {this.amountError = 'Chỉ được nhập số nguyên dương';  count++; }
            if (this.productItem == 0) {this.productError = 'Chọn model sản phẩm';  count++; }
            if (count == 0) {
                this.note_confirm = '';
                var amountValue = 0;
                var variables = {
                    where_key: {
                        production_order_code: {'_eq': this.production_code }
                    }
                }
                var data = await DataServices.getList('production_order', {"variables": JSON.stringify(variables), "fields": "amount", "aggregate": " { aggregate { sum { amount } } }"});
                var list = data[Object.keys(data)];
                if (list != null && Object.keys(list).length) {
                    amountValue = list.aggregate.sum.amount;
                }
                if (amountValue > 0) {
                    this.note_confirm = this.noteConfirm.replace('{0}', '<span style="color:#0000FF;">' + this.production_code + '</span>').replace('{1}', '<span style="color:#F00;">' + amountValue + '</span>');
                    await this.getDataDuplicate();
                }
                this.displayDialog = true;
            } else this.submit = true;
        }
    },
    async getSettings() {
      var variables = {
        where_key: {
          key: {'_eq': 'SERIAL_NUMBER_CREATED'}
        }
      }
      var data = await DataServices.getList('settings', {"variables": JSON.stringify(variables), 'fields' : 'value'});
      if (data != undefined && data != null && data[Object.keys(data)].length) {
        var list = data[Object.keys(data)];
        return list[0].value == 'true';
      }
      return false;
    },
    async confirmCreated() {
        // this.$store.commit('setDataLoading', {content: 'Đang tải dữ liệu', icon: true});
        // this.$store.commit('setLoading', true);
        /*var isProcessing = await this.getSettings();
        if (!isProcessing) {*/
            await DataServices.updateData('settings', {"variables": JSON.stringify({data_update: {value: "true"}, where_key: {key: {'_eq': 'SERIAL_NUMBER_CREATED'}}})});
            this.displayDialog = false;
            this.displayProgressDialog = true;
            this.countDown = this.amount;
            this.callbackCreateSerialNumber();
        /*} else {
            // this.$store.commit('setLoading', false);
            this.$toast.add({ severity: 'warn', summary: 'Thông báo', detail: 'Đang có 1 tiến trình  tạo số serial number đang chạy. Vui lòng đợi trong giây lát', life: 3000 })
        }*/
    },
    cancelCreated() {
        this.displayDialog = false;
        this.submit = false;
    },
    async confirmStopped() {
        this.stopProgress = true;
        await DataServices.updateData('settings', {"variables": JSON.stringify({data_update: {value: "false"}, where_key: {key: {'_eq': 'SERIAL_NUMBER_CREATED'}}})});
        await DataServices.deleteData('product_serial_number', {"variables": JSON.stringify({where_key: {production_order_code: {'_eq': this.production_code}}})});
        await DataServices.deleteData('production_order', {"variables": JSON.stringify({where_key: {production_order_code: {'_eq': this.production_code}}})});
        setTimeout(() => {
            window.location.reload();
        }, 200);
    },
    confirmCancel() {
        this.displayProgressDialog = false;
        this.displayConfirmDialog = true;
        this.submit = false;
    },
    confirmContinue() {
        this.displayConfirmDialog = false;
        this.displayProgressDialog = true;
        this.stopProgress = false;
        this.submit = false;
        this.callbackCreateSerialNumber();
    },
    async callbackCreateSerialNumber() {
        var vm = this;
        var round = 100 / vm.amount;
        var productionOrderID = 0; 
        var createSuccess = false;
        var success = false;
        if (vm.countDown == vm.amount) {
            productionOrderID = await this.createProductionOrder();
            success = productionOrderID != false ? true : false;
        } else if (vm.countDown > 0 ) success = true;
        if (success) {
          var list_insert_serial_number = [];
            while(vm.countDown > 0) {
                var checkData = await vm.createProductionSeriralNumber(productionOrderID);
                if (checkData) {
                  list_insert_serial_number.push(checkData);
                    vm.processRows += Math.round(round);
                    vm.countDown--;
                    if (vm.countDown <= 0 || vm.stopProgress) {
                        if (!vm.stopProgress) {
                            vm.processRows = 100;
                            createSuccess = true;
                        }
                        vm.displayProgressDialog = false;
                        break;
                    }
                } else {
                    vm.displayProgressDialog = false;
                    break;
                }
            }
            if (list_insert_serial_number.length > 0){
              await DataServices.insertData('product_serial_number', {"variables": JSON.stringify({objects: list_insert_serial_number})});
            }
        }
        if (createSuccess) {
            this.$store.commit('setLoading', false);
            await DataServices.updateData('settings', {"variables": JSON.stringify({data_update: {value: "false"}, where_key: {key: {'_eq': 'SERIAL_NUMBER_CREATED'}}})});
            this.$toast.add({ severity: 'success', summary: 'Thông báo', detail: 'Tạo serial number thành công', life: 3000 })
            setTimeout(() => {
                window.location.reload();
            }, 200);
        }
    },
    async createProductionOrder() {
        var dateNow = new Date();
        const [d, M, y] = this.created_date.match(/\d+/g);
        var changeDate = new Date(y, M-1, d, dateNow.getHours(), dateNow.getMinutes(), dateNow.getSeconds());
        var manufacturingDate = this.$myConstants.currentDate(changeDate);
        var params = {
           production_order_code: this.production_code,
           product_id: this.productItem,
           author_id: this.$store.getters.fullname.id,
           manufacturing_date: manufacturingDate,
        //    modifier_id: this.$store.getters.fullname.id,
           prefix_number: this.prefix,
           created_date: this.$myConstants.currentDate(),
           modified_date: this.$myConstants.currentDate(),
           amount: this.amount,
           status: 0
        }
        var returnData = await DataServices.insertData('production_order', {"variables": JSON.stringify({objects: params})});
        if (returnData != null) {
            var checkData = returnData[Object.keys(returnData)];
            if (checkData.affected_rows) {
                var insertData = checkData.returning[0];
                return insertData.id;
            }
        }
        return false;
    },
    async createProductionSeriralNumber(productionOrderID) {
        if (productionOrderID > 0) {
            var params = {
            production_order_id: productionOrderID,
            production_order_code: this.production_code,
            serial_number: (this.prefix + '' + this.$myConstants.generateUniqueId(8)).toUpperCase(),
            product_id: this.productItem,
            created_date: this.$myConstants.currentDate(),
            modified_date: this.$myConstants.currentDate(),
            status: 1,
            production_status: 0,
            warranty_status: 2,
            barcode_relative_path: "",
            qrcode_relative_path: "",
            }
            return params;
            /*var returnData  = await DataServices.insertData('product_serial_number', {"variables": JSON.stringify({objects: params})});
            if (returnData != null) {
                var checkData = returnData[Object.keys(returnData)];
                return  checkData.affected_rows > 0;
            }*/
        }
        return false;
    },
    getRowActions() {
      var actions = {}
      var that = this;
      actions.filter = { name: 'clear', icon: 'times-circle'};
      actions.rows = function (rowData) {
        var buttons = {}
        //if (that.checkVisible('serial_number', 'print') || that.checkVisible('serial_number', 'import') || that.checkVisible('serial_number', 'cancel')) {
        if (that.$myConstants.checkRoleGroup('serial_number_add', 'view_history_serial_number')){
            buttons.view = { name: 'view', text: 'Xem', isText: true, key: 'id', path: `/admin/serial-number/view/`}
            if (that.dataModel.actions) {
            var modelaction = that.dataModel.actions(rowData)
            Object.assign(buttons, modelaction);
            }
        }
        return buttons
      }
      return actions
    },
    async onActionClicked(payload) {
      var action = payload.action
      var data = null
      if (payload.data) {
        data = payload.data
      }
      switch (action.name) {
        case 'view':
        //if (this.checkVisible('serial_number', 'print') || this.checkVisible('serial_number', 'import') || this.checkVisible('serial_number', 'cancel')) {
          if (this.$myConstants.checkRoleGroup('serial_number_add', 'view_history_serial_number')){
            if (action.path !== undefined && action.path) {
                this.$router.push({ path: action.path + data.data[action.key] })
            }
        }
        break;
      }
    },
    async initParams() {
        //this.$store.commit('setDataLoading', {content: 'Đang tải dữ liệu', icon: true});
        //this.$store.commit('setLoading', true);
        this.modelName = 'production_order_list';
        /*var whereKey = {
            status: {'_in': [0, 1, 2] }
        }*/
        /*if (this.$store.getters.fullname.user_type == 2) {
            whereKey = Object.assign(whereKey,  {author_id: {'_eq': this.$store.getters.fullname.id } }) 
        }*/
        /*var variables = {
            where_key: whereKey,
            orderBy: {
                id: 'desc',
                created_date: 'desc',
                modified_date: 'desc'
            }
        }
        var data = await DataServices.getList(this.modelName, {"variables": JSON.stringify(variables)});
        var list = data[Object.keys(data)];*/
        this.dataModel = DataServices.getModel(this.modelName);
        this.dataModel.processData([]);
        this.listData = [];
        this.componentKey++;
        //this.$store.commit('setLoading', false);
    },
    async getDataDuplicate() {
        var whereKey = {
            status: {'_in': [0, 1, 2] },
            production_order_code: {'_eq': this.production_code}
        }
        var variables = {
            where_key: whereKey,
            orderBy: {
                id: 'desc',
                created_date: 'desc',
                modified_date: 'desc'
            }
        }
        var data = await DataServices.getList('production_order_duplicate', {"variables": JSON.stringify(variables)});
        var list = data[Object.keys(data)];
        this.dataModelDuplicate = DataServices.getModel('production_order_duplicate');
        this.dataModelDuplicate.processData(list);
        this.listDataDuplicate = list;
        this.componentKeyDuplicate++;
    },
    async filterExport(e){
      //console.log("EEE",e)
      this.data_filter_export = e
    }
  }
}
</script>

<style lang="scss">
.create-serial-number{ margin: 0 auto; width: 800px;
    .p-field{
        &.width-prefix{width: 125px;}
        &.width-amount{margin-left: 20px; width: 200px; margin-right: 100px;}
        &.width-300{width: 350px;
            &.margin-right{margin-right: 100px;}
        }
        label{font-size: 14px;}
        &.btn-submit{ margin: 20px auto 0 auto;
            .p-button{width: 200px !important; 
                &.disabled{background: #999999; border: 1px solid #999999;}
            }
        }
    }
}
.box-data-duplicate{margin-top: 15px;}
</style>